if (document.getElementById("select-role")) {
  new ChosenCustom({
    selector: document.getElementById("select-role"),
    ID: "selectRole",
    placeholder: "Select role*"
  });
}

if (document.getElementById("need-help")) {
  new ChosenCustom({
    selector: document.getElementById("need-help"),
    ID: "selectHelp",
    placeholder: "I need help with...*",
    multiple: true
  });
}

/**
 * Contact us Form
 */
window.addEventListener("load", function() {
  var formElemSection = document.querySelector(".contact-form"),
    formElemHeight = formElemSection ? formElemSection.offsetHeight : 0;

  // load recaptcha JS after page load
  if (formElemHeight) {
    document.addEventListener("click", loadRecaptchaForForm);
  }

  function loadRecaptchaForForm() {
    if (typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }

    // User token API call
    HeroSalesContact.setCsrfToken();
  }
});

var csrf_token,
  railsHost = bsLib.railsHost(),
  ContactForm = {},
  formElem = document.getElementById("hero-contact-form"),
  checkEmailValidation = false;

ContactForm.formObj = document.getElementById("hero-contact-form");
ContactForm.formObjError = document.querySelector(".contact-form");
ContactForm.nameField = document.getElementById("form-name");
ContactForm.emailField = document.getElementById("form-email");
ContactForm.roleField = document.getElementById("select-role");
ContactForm.needHelpField = document.getElementById("need-help");
ContactForm.requestType = document.getElementById("request_type");
ContactForm.utf8 = document.getElementById("utf_no");
ContactForm.authenticity = document.getElementById("authenticity_token");
ContactForm.contactformSendEmail = document.getElementById("form-send-email");
ContactForm.contactFormCaptcha = document.getElementById("contactformcaptcha");
ContactForm.queryType = document.getElementById("form-query-type");
ContactForm.messageAppendText = document.getElementById("message_append_text");
ContactForm.interactedWithDGForm = true;

/*
 * Get Query Params from JS because WPEngine remove utm_* and gclid from GET object.
 * Ref : https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

document.getElementById("payload_utm_campaign").value = getParameterByName(
  "utm_campaign"
);
document.getElementById("payload_utm_adgroup").value = getParameterByName(
  "utm_adgroup"
);
document.getElementById("payload_gclid").value = getParameterByName("gclid");
document.getElementById("payload_utm_source").value = (getParameterByName("utm_source") ? getParameterByName("utm_source"): "PaidAds");

var HeroSalesContact = (function(csrfToken, ContactForm) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields,
    setCsrfToken: setCsrfToken
  };

  function init() {
    var grecaptchaResponse = grecaptcha.getResponse(),
      email = document.getElementById("form-email").value,
      msg = ContactForm.messageAppendText.value + " ",
      needHelpOpt = document.getElementById("need-help").options,
      form_requestHeader = {
        "X-CSRF-Token": csrfToken,
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8" // Setting content type.
      };

    for (var index = 0; index < needHelpOpt.length; index++) {
      if (needHelpOpt[index].selected) {
        msg += needHelpOpt[index].value + ", ";
      }
    }

    var company = email.substring(email.lastIndexOf("@") + 1).split(".")[0];

    var form_data = {
      name: document.getElementById("form-name").value,
      email: email,
      company: company ? company : "Unknown",
      query_type: document.getElementById("form-query-type").value,
      message: msg.trim(),
      role: document.getElementById("select-role").value,
      send_email: document.getElementById("form-send-email").value,
      authenticity_token: document.getElementById("authenticity_token").value,
      utf8: document.getElementById("utf_no").value,
      request_type: document.getElementById("request_type").value,
      utm_campaign: document.getElementById("payload_utm_campaign").value,
      utm_adgroup: document.getElementById("payload_utm_adgroup").value,
      gclid: document.getElementById("payload_gclid").value,
      utm_source: document.getElementById("payload_utm_source").value,
      page_url: window.location.href,
      cta_ref: getParameterByName("ref"),
      "g-recaptcha-response": grecaptchaResponse,
      ga_cid: bsLib.GAClientID(),
      source: "paid_ads",
      utm_campaigncode: document.querySelector('[name="sfdc_utm_campaigncode"]').value.trim(),
      additional_notes: document.querySelector('[name="additional_notes"]').value.trim(),
      primary_product: document.querySelector('[name="primary_product"]').value.trim(),
      secondary_product: document.querySelector('[name="secondary_product"]').value.trim(),
      previous_page_url: (document.referrer !== '') ? document.referrer : 'organic',
      lead_source: "Contact Sales Form",
      check_email_domain: true
    };

    var form_success = function(data) {
      var dataRequest = bsLib.JSONParse(data.response);
      if (dataRequest.success) {
        //revsure form tracking code on success
        if (typeof window.rudderanalytics !== "undefined") {
          window.rudderanalytics.identify(form_data.email, {email: form_data.email, name: form_data.name, company: form_data.company});
          window.rudderanalytics.track("Form Submission - Contact Sales DG Form");
        }
        
        var tyModalCTABtn = document.querySelector('.thank-you-cta-btn'),
          modalContainer = document.querySelector(".thank-you-modal"),
          customYTModal = document.getElementById("yt_video_id");

        if (customYTModal) {
          var custModalVideoId = customYTModal.value.trim(),
            ua = navigator.userAgent.toLowerCase(),
            isSafari = false,
            sandboxFlag = '';

          // Detect browser for allow presentation sandbox flag
          try {
            isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
          }
          catch(err) {}
          isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
          sandboxFlag = isSafari ? '' : 'allow-presentation';

          if (custModalVideoId) {
            var custModalVideo = new tingle.modal({
              closeIconInverse: true,
              cssClass: ['popup-video'],
              onClose: function() {
                custModalVideo.destroy();
              }
            });
            custModalVideo.setContent(
              '<iframe width="100%" height="400" src="https://www.youtube.com/embed/' +
                custModalVideoId +
                '?autoplay=1" sandbox="allow-scripts allow-same-origin ' + sandboxFlag + '" frameborder="0" allow="autoplay; fullscreen"></iframe>'
            );
            custModalVideo.open();
          }
        } else {
          var modal = new tingle.modal({
            cssClass: tyModalCTABtn ? ["hero-unit-form", "custom-ty-modal-wrapper"] : ["hero-unit-form"],
            onClose: function() {
              modal.destroy();
            }
          });

          modal.setContent(modalContainer.innerHTML);
          modal.open();
        }

        // add click event to TY modal CTA
        var tyModalCTAParent = document.querySelector('.tingle-modal .thank-you-cta-btn');
        if (tyModalCTAParent) {
          tyModalCTAParent.addEventListener("click", function(e) {
            /*
            * close modal without call close function. 
            */
            var elements = document.getElementsByClassName("tingle-modal--visible");
            while (elements.length > 0) elements[0].remove();
      
            //remove from body class
            document.body.className = document.body.className.replace("tingle-enabled","");
            document.getElementById('page__wrapper').setAttribute('aria-hidden', false);
          });
        }

        _afterSubmitSuccess();
        _logFormSubmit("FormSubmitSuccess");
      } else if (dataRequest.field && dataRequest.message) {
        checkEmailValidation = false;
        switch (dataRequest.field) {
          case "nameField":
            _showError(
              ContactForm.nameField,
              document.getElementById("name-error"),
              "name-error",
              dataRequest.message
            );
            break;
          case "emailField":
            _showError(
              ContactForm.emailField,
              document.getElementById("email-error"),
              "email-error",
              dataRequest.message
            );
            break;
          case "roleField":
            _showError(
              ContactForm.roleField,
              document.getElementById("role-error"),
              "role-error",
              dataRequest.message
            );
            break;
          case "messageField":
            _showError(
              ContactForm.needHelpField,
              document.getElementById("need-help-error"),
              "need-help-error",
              dataRequest.message
            );
            break;
          case "business_email":
            _showError(
              ContactForm.emailField,
              document.getElementById("email-error"),
              "email-error",
              dataRequest.message
            );
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.value = submitBtn.dataset.valueText;
            }
            grecaptcha.reset();
            checkEmailValidation = true;
            break;
          default:
            new bsAlert({
              alertType: "error",
              timeout: 10000,
              htmlMessage: true,
              text: dataRequest.message
            });
        }
      }
    };

    var form_error = function() {
      _logFormSubmit("FormSubmitError");
    };

    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      railsHost + "/contact",
      form_data,
      false,
      form_requestHeader,
      form_success,
      form_error
    );
  }

  function setCsrfToken() {
    // XHR request for user token
    if (!csrf_token) {
      // XHR request for user token
      bsLib.ajax(
        "GET",
        railsHost + "/user/token.json",
        {},
        false,
        {},
        // Success message for user token.
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);
          ContactForm.authenticity.value = dataRequest.csrf_token;
          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        },
        // Custom Error message for user token.
        function() {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    } else if (!csrfToken) {
      csrfToken = csrf_token;
    }
  }

  function _validateFields() {
    var formValid = true,
      namerError = document.getElementById("name-error"),
      emailError = document.getElementById("email-error"),
      roleError = document.getElementById("role-error"),
      needHelpError = document.getElementById("need-help-error"),
      recaptchaError = document.getElementById("recaptcha-error"),
      grecaptchaResponse =
        typeof grecaptcha !== "undefined" ? grecaptcha.getResponse() : "";

    //name field
    if (ContactForm.nameField.value.length === 0) {
      formValid = _showError(
        ContactForm.nameField,
        namerError,
        "name-error",
        Messages.salesAndSupportPage.invalidName
      );
    } else {
      ContactForm.nameField.classList.remove("error-border");
      if (namerError) {
        namerError.remove();
      }
    }

    //remove existing email error
    if (emailError) {
      emailError.remove();
    } 

    //error field
    if (ContactForm.emailField.value == "") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        "email-error",
        Messages.salesAndSupportPage.noemail
      );
    } else if (!bsLib.validEmail(ContactForm.emailField.value)) {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        "email-error",
        Messages.salesAndSupportPage.invalidEmail
      );
    } else if (ContactForm.emailField.dataset.notvalid === "1") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidWorkEmail
      );
    } else {
      ContactForm.emailField.classList.remove("error-border");
      if (emailError) {
        emailError.remove();
      }
    }

    //role field
    if (ContactForm.roleField.value.length === 0) {
      formValid = _showError(
        ContactForm.roleField,
        roleError,
        "role-error",
        Messages.salesAndSupportPage.invalidRole
      );
    } else {
      ContactForm.roleField.classList.remove("error-border");
      if (roleError) {
        roleError.remove();
      }
    }

    if (ContactForm.needHelpField.value.length === 0) {
      formValid = _showError(
        ContactForm.needHelpField,
        needHelpError,
        "need-help-error",
        Messages.salesAndSupportPage.invalidNeedHelp
      );
    } else {
      ContactForm.needHelpField.classList.remove("error-border");
      if (needHelpError) {
        needHelpError.remove();
      }
    }

    if (grecaptchaResponse.length === 0) {
      formValid = _showError(
        ContactForm.contactFormCaptcha,
        recaptchaError,
        "recaptcha-error",
        Messages.salesAndSupportPage.noRecaptcha
      );
    } else {
      ContactForm.contactFormCaptcha.classList.remove("error-border");
      if (recaptchaError) {
        recaptchaError.remove();
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);

    var eventName;
    switch (fieldName.getAttribute("name")) {
      case "name":
        eventName = "CsfInteractedWithNameField";
        break;
      case "email":
        eventName = "CsfInteractedWithEmailField";
        break;
      case "select-role":
        eventName = "CsfInteractedWithRoleField";
        break;
      case "need-help":
        eventName = "CsfInteractedWithNeedHelpField";
        break;
      default:
      // DO nothing
    }

    if (fieldName.getAttribute("id") == "contactformcaptcha") {
      eventName = "CsfInteractedWithCaptcha";
    }

    if (eventName) {
      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent(eventName, {
        InvalidInput: true,
        message: errorMessage
      }) : '';
    }
  }

  function _afterSubmitSuccess() {
  //linkedIn Pixel
  if (window.lintrk !== undefined) {
    window.lintrk('track', {conversion_id: 9342705});
  }

    resetForm();
  }

  function resetForm() {
    ContactForm.formObj.reset(); //Reset form

    //reset chosen
    if (document.getElementById("select-role")) {
      new ChosenCustom({
        selector: document.getElementById("select-role"),
        ID: "selectRole",
        placeholder: "Select role*",
        reset: true
      });
    }

    if (document.getElementById("need-help")) {
      new ChosenCustom({
        selector: document.getElementById("need-help"),
        ID: "selectHelp",
        placeholder: "I need help with...*",
        multiple: true,
        reset: true
      });
    }

    if (ContactForm.contactFormCaptcha && typeof grecaptcha !== "undefined") {
      grecaptcha.reset();
    }
  }

  function _logFormSubmit(status) {
    var data = {},
      queryType = document
        .getElementById("form-query-type")
        .getAttribute("data-query-text"),
      queryVal = document
        .getElementById("form-query-type")
        .getAttribute("value");

    data.experiment = "false";
    data[status] = true;
    data.QueryTypeSubmitted = queryType ? queryType : "No query type";
    WebEventTracker.logEvent(EDS.webEvents, "SubmitDGContactForm", data);
    if (typeof ga !== "undefined") {
      ga("browserstack.send", "event", {
        eventCategory: "Contact",
        eventAction: "CtaClick",
        eventLabel: "Submit",
        eventValue: queryVal
      });
      // Conversion tracking for corporate ID form
      ga('browserstack.send', 'event', 'lead', 'conversion', 'corporate_form_submission');
    }
  }
})(csrf_token, ContactForm);

//Interact with google captcha
function InteractWithContactFormCaptcha() {
  window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("CsfInteractedWithCaptcha", {}) : '';
  if (ContactForm.interactedWithDGForm) {
    window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("InteractedWithDGForm", {}) : '';
    ContactForm.interactedWithDGForm = false;
  }
}

function intereactedWithFormField(eventname) {
  window.hasOwnProperty('Amplitude') ? Amplitude.logEvent(eventname, {}) : '';
  if (ContactForm.interactedWithDGForm) {
    window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("InteractedWithDGForm", {}) : '';
    ContactForm.interactedWithDGForm = false;
  }
}

document.addEventListener("DOMContentLoaded", function() {
  //Interacted with fields
  ContactForm.nameField.addEventListener("blur", function(event) {
    intereactedWithFormField("CsfInteractedWithNameField");
  });

  ContactForm.emailField.addEventListener("blur", function(event) {
    intereactedWithFormField("CsfInteractedWithEmailField");

    //validation for corporate emails
    var validEmail = true,
      that = this,
      submitBtn = document.getElementById("csf-corporate-form"),
      emailError = document.getElementById("email-error");

    if ( checkEmailValidation ) {
      return;
    }
    //false valid dataset
    that.dataset.notvalid = "0";

    //remove existing error
    if (emailError) {
      emailError.remove();
    }

    if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
      validEmail = false;
      
      that.classList.add("error-border");
      that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (that.value.length == 0 ? Messages.salesAndSupportPage.noemail : Messages.salesAndSupportPage.invalidEmail) + '</span>');
    } else {
      that.classList.remove("error-border");
    }

    if (validEmail) {
      //Disable submit button
      if (submitBtn) {
        submitBtn.setAttribute("disabled", "disabled");
        submitBtn.value = Messages.salesAndSupportPage.validateText;
      }

      bsLib.ajax(
        "GET",
        bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value) + "&source=paid_ads",
        {},
        true,
        {
          "X-CSRF-Token": csrf_token,
          "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
        },
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);

          //remove disable
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
            submitBtn.value = submitBtn.dataset.valueText;
          }

          if (dataRequest.valid === false) {
            that.dataset.notvalid = "1";

            that.classList.add("error-border");
            if (that.parentNode.getElementsByClassName("error-message").length === 0) {
              that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.salesAndSupportPage.invalidWorkEmail + '</span>');
            }
          }
        },
        function() {}
      );
    }
  });

  ContactForm.roleField.addEventListener("change", function(event) {
    intereactedWithFormField("CsfInteractedWithRoleField");
  });

  ContactForm.needHelpField.addEventListener("change", function(event) {
    intereactedWithFormField("CsfInteractedWithNeedHelpField");
  });

  //Submit Contact Form
  formElem.addEventListener("submit", function(e) {
    e.preventDefault();

    if (!HeroSalesContact.validateFields()) {
      return false;
    }

    if (grecaptcha !== "undefined") {
      HeroSalesContact.init();
    }
    return false;
  });
});